import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=d7d65a36&"
import script from "./teams.ts?vue&type=script&lang=js&"
export * from "./teams.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports